﻿let htmlTemplates: Array<Template> = [];
const langCode = document.documentElement.lang;

class Template
{
    name: string;
    template: Array<TemplateSite>;
};

class TemplateSite
{
    siteID?: number;
    languageCode?: string;
    countryCode?: string;
    template: string;
}

// Get HTML template for current site and language.
export const getTemplate = (templateName: string): string =>
{
    const template = htmlTemplates.find(t => t.name === templateName);
    if (!template)
        return null;

    const siteTemplate = template.template.find(s => s.siteID === shopConfig().currentSiteID);
    if (siteTemplate)
        return siteTemplate.template;

    const languageTemplate = template.template.find(s => s.languageCode === langCode);
    if (languageTemplate)
        return languageTemplate.template;

    return template.template[0].template;


};

// Fill templates
const productCardTemplates = () =>
{
    const productCard: Template = {
        name: "catviewproduct.html",
        template: [
            {
                languageCode: "NL",
                template: `<div class="w-productcard__holder w-productcard__holder--pnone" data-articleid="{aID}"data-sku="{sku}" data-name="{name}" data-brand="{brand}" data-category="{articlegroup}" data-price="{priceeuroonly}.{pricecent}"data-variant="{variant}" data-position="{index}" data-material="{material}" data-stuffing="{stuffing}" data-season="{season}"data-deliverytime="{deliverytime}" data-articlenumber="{articlenr}" data-sleepingposition="{sleepingposition}"data-firmness="{firmness}" data-stock="{hasstock}" data-type="{type}" data-thermalclass="{thermalclass}"><article class="w-productcard br-2xl"><a class="w-productcard__image-holder o-2xl" href="{url}" title="{title}" tabindex="-1" aria-hidden="true">{foreach images}<img class="w-productcard__image lazy" height="250" width="250" fetchpriority="{fetchpriority_6_high}" alt="{title}" rel="{title}"data-src="{staticDomain}{imageDetail}" data-srcset="{staticDomain}{image} 1.5x, {staticDomain}{imageDetail} 1x"sizes="(min-resolution: 144dpi) 1.5x, (-webkit-min-device-pixel-ratio: 1.5) 1.5x, 1x"src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="{imgstyle} data-imgtype="{imageType}" />{/foreach}</a><div class="w-productcard__content-holder"><a class="w-productcard__content-priceblock" href="{url}" title="{title}"><div class="w-productcard__content-prices"><span class="w-productcard__content-prices--from {showforlowestprice}">Vanaf</span><span class="w-productcard__content-prices--old {hide_old_price}">{incvatoldpriceformatted}</span><span class="w-productcard__content-prices--new">{incvatpriceformatted}</span></div><div class="w-productcard__content-view"><div class="w-productcard__content-view-btn btn-link btn-border-flow ic-chevron-right-aft p-linkicon">Bekijk</div></div></a><div class="w-productcard__content"><a class="w-productcard__content-link" href="{url}" title="{name}" tabindex="-1" aria-hidden="true"><span class="w-productcard__content-title">{brand}</span><span class="w-productcard__content-text">{summary}</span></a><div class="c-productcompare__product-block js-productcompare-toggle" data-productid="{id}" data-articleid="{aID}"><div class="u-checkradio-holder"><input type="checkbox" id="c-productcompare__product-{aID}" name="c-productcompare__product-{aID}" /><label for="c-productcompare__product-{aID}">Vergelijk</label></div></div></div></div><div class="w-productcard__favorite-block js-favorite-article {added}" data-articleid="{aID}"><div class="w-productcard__favorite-active btn-icon btn-icon-after ic-heart-full-aft"></div><div class="w-productcard__favorite-inactive btn-icon btn-icon-after ic-heart-aft"></div></div>{button}</article></div>`
            },
            {
                languageCode: "FR",
                template: `<div class="w-productcard__holder w-productcard__holder--pnone" data-articleid="{aID}"data-sku="{sku}" data-name="{name}" data-brand="{brand}" data-category="{articlegroup}" data-price="{priceeuroonly}.{pricecent}"data-variant="{variant}" data-position="{index}" data-material="{material}" data-stuffing="{stuffing}" data-season="{season}"data-deliverytime="{deliverytime}" data-articlenumber="{articlenr}" data-sleepingposition="{sleepingposition}"data-firmness="{firmness}" data-stock="{hasstock}" data-type="{type}" data-thermalclass="{thermalclass}"><article class="w-productcard br-2xl"><a class="w-productcard__image-holder o-2xl" href="{url}" title="{title}" tabindex="-1" aria-hidden="true">{foreach images}<img class="w-productcard__image lazy" height="250" width="250" fetchpriority="{fetchpriority_6_high}" alt="{title}" rel="{title}"data-src="{staticDomain}{imageDetail}" data-srcset="{staticDomain}{image} 1.5x, {staticDomain}{imageDetail} 1x"sizes="(min-resolution: 144dpi) 1.5x, (-webkit-min-device-pixel-ratio: 1.5) 1.5x, 1x"src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="{imgstyle} data-imgtype="{imageType}" />{/foreach}</a><div class="w-productcard__content-holder"><a class="w-productcard__content-priceblock" href="{url}" title="{title}"><div class="w-productcard__content-prices"><span class="w-productcard__content-prices--from {showforlowestprice}">Vanaf</span><span class="w-productcard__content-prices--old {hide_old_price}">{incvatoldpriceformatted}</span><span class="w-productcard__content-prices--new">{incvatpriceformatted}</span></div><div class="w-productcard__content-view"><div class="w-productcard__content-view-btn btn-link btn-border-flow ic-chevron-right-aft p-linkicon">D&eacute;couvrir</div></div></a><div class="w-productcard__content"><a class="w-productcard__content-link" href="{url}" title="{name}" tabindex="-1" aria-hidden="true"><span class="w-productcard__content-title">{brand}</span><span class="w-productcard__content-text">{summary}</span></a><div class="c-productcompare__product-block js-productcompare-toggle" data-productid="{id}" data-articleid="{aID}"><div class="u-checkradio-holder"><input type="checkbox" id="c-productcompare__product-{aID}" name="c-productcompare__product-{aID}" /><label for="c-productcompare__product-{aID}">Comparer</label></div></div></div></div><div class="w-productcard__favorite-block js-favorite-article {added}" data-articleid="{aID}"><div class="w-productcard__favorite-active btn-icon btn-icon-after ic-heart-full-aft"></div><div class="w-productcard__favorite-inactive btn-icon btn-icon-after ic-heart-aft"></div></div>{button}</article></div>`
            }
        ]
    };

    htmlTemplates.push(productCard);

    const productSizes: Template = {
        name: "product.sizes.html",
        template: [
            {
                template: `<input type="hidden" class="product-sizes-count" value="{size_count}" />`
            }
        ]
    };

    htmlTemplates.push(productSizes);

    const productSizesSingle: Template = {
        name: "product.sizes.single.html",
        template: [
            {
                template: `<input type="hidden" class="product-sizes-count" value="{size_count}" />`
            }
        ]
    };

    htmlTemplates.push(productSizesSingle);

    const remainingStock: Template = {
        name: "remainingstock.html",
        template: [
            {
                languageCode: "NL",
                template: `<div class="remainingstock">Nog slechts {stock} op voorraad</div>`
            },
            {
                languageCode: "FR",
                template: `<div class="remainingstock">Plus que {stock} en stock</div>`
            }
        ]
    };

    htmlTemplates.push(remainingStock);
};

const bulletTemplates = () =>
{
    const bullet: Template = {
        name: "productdetail.button.html",
        template: [
            {
                template: `<div class="bullet {button_class}" data-sku="{ean}"><div>{first}{second}</div><script type="text/javascript">if (typeof buttonImpressionList === 'undefined' || buttonImpressionList == null)buttonImpressionList = new Array();if (typeof buttonInfoList === 'undefined' || buttonInfoList == null)buttonInfoList = new Array();if ('{ean}' in buttonInfoList) { }else{buttonInfoList['{ean}'] = {'promotion_id': '{button_name}','promotion_name': '{button_name}','creative_name': '{button_class}','creative_slot': '{ean}'};buttonImpressionList.push(buttonInfoList['{ean}']);}</script></div>`
            }
        ]
    };

    htmlTemplates.push(bullet);

    const bulletInner: Template = {
        name: "productdetail.button0.html",
        template: [
            {
                template: `<span class="{css_class}">{text}</span>`
            }
        ]
    };

    htmlTemplates.push(bulletInner);
};

const filterTemplates = () =>
{
    const sliderFilter: Template = {
        name: "filter_range_item.html",
        template: [
            {
                template: `<div class="w-filter__slide w-filter__slide--property propertyslider {name}" data-property-id="{property_id}"><div class="range-holder"><div class="w-filter__slide-units ui-slider"><span class="property-handler w-filter__slide-units--first first f-primary-s"><span class="num"></span><span class="unit">{unit}</span></span><span class="property-handler w-filter__slide-units--last last f-primary-s"><span class="num"></span><span class="unit">{unit}</span></span></div><input type="hidden" name="prop-id" class="range-prop-id" value="{property_id}" /><input type="hidden" name="prop-name" class="range-name" value="{name}" /><input type="hidden" name="prop-org-name" class="range-org-name" value="{orgName}" /><input type="hidden" name="prop-min" class="prop-min" value="{min}" /><input type="hidden" name="prop-max" class="prop-max" value="{max}" /><input type="hidden" name="prop-cur-min" class="prop-cur-min" value="{curMin}" /><input type="hidden" name="prop-cur-max" class="prop-cur-max" value="{curMax}" /><input type="hidden" name="prop-unit" class="prop-unit" value="{unit}" /><input type="hidden" class="step" value="{step}" /></div></div>`
            }
        ]
    };

    htmlTemplates.push(sliderFilter);

    const priceFilter: Template = {
        name: "search_price.html",
        template: [
            {
                template: `<input type="hidden" name="min" class="min" value="{min}" /><input type="hidden" name="max" class="max" value="{max}" /><input type="hidden" name="price-min" class="cur-min" value="{curMin}" /><input type="hidden" name="price-max" class="cur-max" value="{curMax}" /><input type="hidden" class="step" value="5" />`
            }
        ]
    };

    htmlTemplates.push(priceFilter);
};

const wizardTemplates = () =>
{
    const filterWizardIntroduction: Template = {
        name: "filterwizard.introduction.html",
        template: [
            {
                template: "<div class=\"md-content-wrapper md-content-norel modal-content\"><input type=\"hidden\" id=\"currentWizardStep\" value=\"-1\" /><input type=\"hidden\" id=\"currentWizardID\" value=\"{wizardID}\" /><input type=\"hidden\" id=\"nextWizardStep\" value=\"0\" /><div class=\"c-filterwizard-option-content__image-container\"><img class=\"c-filterwizard-option-content__image\" rel=\"{title}\" src=\"{staticDomain}/data/cms_uploads/webshop/webshop/wizard/{image}\" alt=\"{title}\" /></div><div class=\"wizard-introduction-text\">{description}</div><div class=\"wizard-introduction-footer\"><button class=\"btn btn-icon-right btn-arrow-right wizard-introduction-button\">{button_text}</button></div></div>"
            }
        ]
    }

    htmlTemplates.push(filterWizardIntroduction);

    const filterWizardStep: Template = {
        name: "filterwizard.step.html",
        template: [
            {
                template:
                    `<div class="md-content-wrapper md-content-norel modal-content">
                        {foreach steps}<div tabindex="0" class="hidden wizard-step-item" data-property-id="{propertyID}" data-priority="{priority}" data-order="{order}"></div>{/foreach}
                        <input type="hidden" id="currentWizardStep" value="{currentStep}" />
                        <input type="hidden" id="currentWizardID" value="{wizardID}" />
                        <input type="hidden" id="nextWizardStep" value="{nextStep}" />
                        <input type="hidden" id="currentWizardProperty" value="{propertyID}" />
                        <div class="md-content c-filterwizard">
                            <div class="c-filterwizard__options"> 
                            {options} 
                            </div>
                        </div>
                    </div>`
            }
        ]
    }

    htmlTemplates.push(filterWizardStep);

    const filterWizardOptionColor: Template = {
        name: "filterwizard.step.option.color.html",
        template: [
            {
                template: "<div tabindex=\"0\" class=\"keyboard-clickable c-filterwizard__option c-filterwizard-option__color\" data-property=\"{propertyID}\" data-option=\"{optionID}\" data-color=\"{colorCode}\"><div class=\"c-filterwizard-option-color__square\" style=\"background-color: {colorCode};\"></div><div class=\"c-filterwizard-option-content__title js-option-name f-primary-s tl-alignm\">{title}</div></div>"
            }
        ]
    }

    htmlTemplates.push(filterWizardOptionColor);

    const filterWizardOptionColorMulti: Template = {
        name: "filterwizard.step.option.color.multi.html",
        template: [
            {
                template: "<div tabindex=\"0\" class=\"keyboard-clickable c-filterwizard__option c-filterwizard-option__color\" data-property=\"{propertyID}\" data-option=\"{optionID}\" data-color=\"{colorCode}\"><div class=\"c-filterwizard-option-color__square\" style=\"background-color: #FFFFFF; background-image:url('{staticDomain}{colorImageLocation}multi_kleuren.jpg'); background-size: cover;\"></div><div class=\"c-filterwizard-option-content__title js-option-name f-primary-s tl-alignm\">{title}</div></div>"
            }
        ]
    }

    htmlTemplates.push(filterWizardOptionColorMulti);

    const filterWizardOption: Template = {
        name: "filterwizard.step.option.html",
        template: [
            {
                template: "<div tabindex=\"0\" class=\"keyboard-clickable c-filterwizard__option c-filterwizard-option {steptype}\" data-property=\"{propertyID}\" data-option=\"{optionID}\"><div class=\"u-checkbox-div\"><input type=\"checkbox\" class=\"u-checkbox-replacement js-checkbox-replacement\" /></div><div class=\"c-filterwizard-option__content\"><div class=\"c-filterwizard-option-content__title js-option-name f-primary-s\">{title}</div><div class=\"f-primary-xs c-filterwizard-option-content__text\">{description}</div></div><div class=\"c-filterwizard-option__image\"></div></div>"
            }
        ]
    }

    htmlTemplates.push(filterWizardOption);

    const filterWizardOptionImage: Template = {
        name: "filterwizard.step.option.image.html",
        template: [
            {
                template: "<div tabindex=\"0\" class=\"keyboard-clickable c-filterwizard__option c-filterwizard-option--image\" data-property=\"{propertyID}\" data-option=\"{optionID}\"><div class=\"u-checkbox-div\"><input type=\"checkbox\" class=\"u-checkbox-replacement js-checkbox-replacement\" /></div><div class=\"c-filterwizard-option__content\"><div class=\"c-filterwizard-option-content__title js-option-name f-primary-s\">{title}</div><div class=\"f-primary-xs c-filterwizard-option-content__text\">{description}</div></div><div class=\"c-filterwizard-option__image\"><img class=\"c-filterwizard-option-content__image\" rel=\"{title}\" src=\"{staticDomain}/data/cms_uploads/webshop/webshop/wizard/option/{image}\" srcset=\"{staticDomain}/data/cms_uploads/webshop/webshop/wizard/option/highdpi/{image} 1.5x, {staticDomain}/data/cms_uploads/webshop/webshop/wizard/option/{image} 1x\" sizes=\"(min - resolution: 144dpi) 1.5x, (-webkit - min - device - pixel - ratio: 1.5) 1.5x, 1x\" alt=\"{title}\" /></div></div>"
            }
        ]
    }

    htmlTemplates.push(filterWizardOptionImage);
};

const filterExplanationTemplates = () =>
{
    const explanationPopup: Template = {
        name: "filter.explanation.popup.html",
        template: [
            {
                template: "<div class=\"md-content-wrapper md-content-norel modal-content\"><div class=\"md-content c-explanation-popup__content\"><div class=\"c-explanation-popup-content__options\"> {options} </div></div></div></div>"
            }
        ]
    }

    htmlTemplates.push(explanationPopup);

    const explanationPopupImage: Template = {
        name: "filter.explanation.option.image.html",
        template: [
            {
                template: "<div class=\"c-explanation-popup__option--image\" data-property=\"{propertyID}\" data-option=\"{optionID}\"><div class=\"u-checkbox-div\"><input type=\"checkbox\" class=\" u-checkbox-replacement js-checkbox-replacement\" /></div><div class=\"c-explanation-popup-option__left\"><div class=\"f-primary-s c-explanation-popup-option__title f-primary-margin-half\">{title}</div><div class=\"f-primary-xs c-explanation-popup-option__text hideempty\">{description}</div></div><div class=\"c-explanation-popup-option__right\"><img class=\"c-explanation-popup-option__right\" rel=\"{title}\" src=\"{staticDomain}/data/cms_uploads/webshop/webshop/filterexplanation/{image}\" srcset=\"{staticDomain}/data/cms_uploads/webshop/webshop/filterexplanation/highdpi/{image} 1.5x, {staticDomain}/data/cms_uploads/webshop/webshop/filterexplanation/{image} 1x\" sizes=\"(min-resolution: 144dpi) 1.5x, (-webkit-min-device-pixel-ratio: 1.5) 1.5x, 1x\" alt=\"{title}\" /></div></div>"
            }
        ]
    }

    htmlTemplates.push(explanationPopupImage);

    const explanationPopupOption: Template = {
        name: "filter.explanation.option.html",
        template: [
            {
                template: "<div class=\"c-explanation-popup__option\" data-property=\"{propertyID}\" data-option=\"{optionID}\"><div class=\"u-checkbox-div\"><input type=\"checkbox\" class=\"u-checkbox-replacement js-checkbox-replacement\" /></div><div class=\"c-explanation-popup-option__left\"><div class=\"f-primary-s f-primary-margin-half\">{title}</div><div class=\"f-primary-xs hideempty\">{description}</div></div><div class=\"c-explanation-popup-option__right\"></div></div>"
            }
        ]
    }

    htmlTemplates.push(explanationPopupOption);
}

const impressionTemplates = () =>
{
    const impression: Template = {
        // No HTML file exists for it.
        name: "catviewimpression",
        template: [
            {
                template: `<script type="text/javascript">if (typeof impressionList === "undefined" || impressionList == null) impressionList = [];if (typeof productInfoList === "undefined" || productInfoList == null) productInfoList = [];var featuredNode = document.getElementById("w-productcard__holder-{aID}");var featuredItemIndex = Array.prototype.indexOf.call(featuredNode.parentNode.childNodes, featuredNode);impressionList.push({ "aid": "{aID}", "id": "{ean}", "sku": "{sku}", "name": "{titlejsEscaped}", "brand": "{brand}", "category": "{categoryTree}", "price": "{priceeuroonly}.{pricecent}", "variant": "{variant}", "position": featuredItemIndex, "categorytree": "{categoryTree}"});productInfoList["{id}"] = "{sku}";</script>`
            }
        ]
    }

    htmlTemplates.push(impression);
}

// Fill array with all templates
const pushTemplates = () =>
{
    productCardTemplates();
    bulletTemplates();
    filterTemplates();
    wizardTemplates();
    filterExplanationTemplates();
    impressionTemplates();
};

pushTemplates();

(window as any).getTemplate = getTemplate;
